<template>
	<div>
		<Modal :onClose="onClose">
			<div slot="header">Edit Channel</div>
			<!-- Form Nav -->
			<div class="form-step-nav">
				<div class="nav-item" :class="{'active': isCurrentStep(1)}" @click.stop="changeStep(1)">
					<div class="title">Information</div>
				</div>
				<div class="nav-item" :class="{'active': isCurrentStep(2)}"  @click.stop="changeStep(2)">
					<div class="title">Service</div>
				</div>
			</div>
			<!-- Update info -->
			<form class="form-step" v-on:submit.prevent="onUpdateInformation" v-if="isCurrentStep(1)">
				<div class="form-error" v-if="statusMessage.error">
					<div class="alert alert-danger" role="alert">
					  <span>Sorry, Channel can't be updated</span>
					  <ul>
					  	<li v-for="(error, index) in statusMessage.error" :key="index">{{error}}</li>
					  </ul>
					</div>
				</div>
				<div class="form-detail">
					<div class="row">
						<div class="col-md-12">
							<form-group :error="getError(error, 'name')">
								<label for="name">Name</label>
								<input type="text" class="form-control" placeholder="Name" v-model="channel.name" autofocus required />
							</form-group>
						</div>
						<div class="col-md-12">
							<form-group :error="getError(error, 'description')">
								<label for="name">Description</label>
								<input type="text" class="form-control" placeholder="Description" v-model="channel.description" />
							</form-group>
						</div>
            <div class="col-md-12">
              <form-group>
                <label for="name">Stream Url</label><br/>
                <input type="text" class="form-control" placeholder="Stream URL for previewing in the console" v-model="channel.streamUrl" />
              </form-group>
            </div>
            <div class="col-md-12">
              <form-group>
                <label for="name">Subscriber url</label>
                <div class="input-group">
                  <input type="url" class="form-control" :value="channel.subscriberUrl" readonly>
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      v-clipboard="() => channel.subscriberUrl">
                      {{buttonCopyText}}
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">Pass <strong>Subscribers URL</strong> into options of ByteArk Firework Plugin</small>
              </form-group>
            </div>
					</div>
				</div>
				<div class="form-actions">
					<div class="row">
						<div class="col-md-12">
							<button type="submit" class="btn btn-success btn-block" :disabled="!isValidUpdateInfo">Update Information</button>
						</div>
					</div>
				</div>
			</form>
			<!-- Choose Service -->
			<form class="form-step" v-on:submit.prevent="onUpdateService" v-if="isCurrentStep(2)">
				<div class="form-error" v-if="statusMessage.error">
					<div class="alert alert-danger" role="alert">
					  <span>Sorry, Channel can't be updated</span>
					  <ul>
					  	<li v-for="(error, index) in statusMessage.error" :key="index">{{error}}</li>
					  </ul>
					</div>
				</div>
				<div class="form-detail">
					<div class="row">
						<div class="col-md-12">
							<ChooseServiceList
								v-model="channel.serviceId"
								:services="services" />
						</div>
					</div>
				</div>
				<div class="form-actions">
					<div class="row">
						<div class="col-md-12">
							<button type="submit" class="btn btn-success btn-block" :disabled="!isValidSubmit">Change</button>
						</div>
					</div>
				</div>
			</form>
		</Modal>
	</div>
</template>

<script>
/* eslint object-shorthand: "off" */
import _ from 'lodash';
import { getError, isValidURL } from '@/modules/utilities';
import ChooseServiceList from '@/components/parts/service/ChooseServiceList';
import Modal from '@/components/elements/Modal';
import FormGroup from '@/components/elements/FormGroup';

export default {
	props: ['onClose', 'onSubmit', 'selectedChannel', 'statusMessage', 'services'],
	components: {
		ChooseServiceList,
		Modal,
		FormGroup,
	},
	data() {
		return {
			step: 1,
			channel: {
				name: null,
				description: null,
				streamUrl: null,
			},
      buttonCopyText: 'Copy',
			error: {
				name: null,
				description: null,
				streamUrl: null,
			},
			minStep: 1,
			maxStep: 2,
		};
	},
	created() {
		this.channel = _.cloneDeep(this.selectedChannel);
	},
	computed: {
		isValidUpdateInfo() {
			return this.channel.name &&
				this.channel.streamUrl &&
				this.isValidURL(this.channel.streamUrl) &&
				!this.statusMessage.isSaving;
		},
		isValidSubmit() {
			return this.channel.name &&
				this.channel.streamUrl &&
				this.channel.serviceId &&
				!this.statusMessage.isSaving;
		},
	},
	watch: {
		'channel.streamUrl'(newVal) {
			if (this.isValidURL(newVal)) {
				this.error.streamUrl = '';
			} else {
				this.error.streamUrl = 'invalid url format';
			}
		},
	},
	methods: {
		getError,
		isValidURL,
		isCurrentStep(step) {
			return this.step === step;
		},
		changeStep(step) {
			if (step > this.maxStep) {
				this.step = this.maxStep;
			} else if (step < this.minStep) {
				this.step = this.minStep;
			} else {
				this.step = step;
			}
		},
		onUpdateInformation() {
			const newInformation = {
				name: this.channel.name,
				description: this.channel.description,
				streamUrl: this.channel.streamUrl,
			};
			const payload = _.defaults(newInformation, this.selectedChannel);
			this.onSubmit(payload);
		},
		onUpdateService() {
			const newService = { serviceId: this.channel.serviceId };
			const payload = _.defaults(newService, this.selectedChannel);
			this.onSubmit(payload);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/parts/channel/EditChannelModal.vue